<template>
  <div class="error-view">
    <nice-icon icon="logo" class="error-view-icon"></nice-icon>
    <div class="box">
      <h1>{{ title }}</h1>
      <p>{{ message }}</p>
      <div class="text-right mt-3">
        <router-link :to="{ name: 'loading' }" class="btn btn-danger" v-translate>Back home</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import gettext from "@/language";
const { $gettext } = gettext;
import { ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const title = ref(route.query.title || $gettext("Error"));
const message = ref(route.query.message || $gettext("Unknown error"));
</script>

<style lang="scss" scoped>
.error-view {
  background: var(--danger-color);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  gap: 2rem;

  .error-view-icon {
    height: 100px;
    color: white;
  }

  .box {
    width: 400px;
    max-width: 90%;

    p {
      margin: 0;
    }
  }
}
</style>
